// extracted by mini-css-extract-plugin
export default {"wrapper":"Y4-z","play":"Z4-z"};